<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import VueBootstrapAutocomplete from '@vue-bootstrap-components/vue-bootstrap-autocomplete'
import { toast, variants } from "@/helpers/toaster";
import ConfirmationModal from '../../../components/confirmationModal.vue';

export default {
  page: {
    title: "Objekti",
  },
  components: {PageHeader, Layout, VueBootstrapAutocomplete, ConfirmationModal},
  props: {
  },
  data() {
    return {
      title: 'Objekti',
      fields: [
        {key: 'object_name', label: 'Ime', sortable: false},
        {key: 'object_code', label: 'Šifra', sortable: false},
        {key: 'user.email', label: 'Email', sortable: false},
        {key: 'partner_id', sortable: false},
        {key: 'object_id', sortable: false},
      ],
      employees: [],
      administrators: [],
      selectedAdministrator: null,
    }
  },
  computed: {
  },
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      const {data} = await axios.get('/super-admin/administrators');
      this.administrators = data;

    } catch (e) {
      // eslint-disable-next-line no-empty
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  watch: {
    async selectedAdministrator() {
      await this.loadEmployees();
    },
  },
  methods: {
    async downloadEmployeesFomAdmin() {
      if (!this.selectedAdministrator)
        return;

      this.$store.commit('loader/START_LOADING');
      try {
        const response = await axios.get(`/super-admin/employees/export/${this.selectedAdministrator.id}`, {
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'spisak_objekta.xlsx');
        document.body.appendChild(link);
        link.click();
        toast('Uspešno preuzimanje spiska objekta.', variants.SUCCESS)
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async loadEmployees() {
      if (!this.selectedAdministrator) return;

      this.$store.commit('loader/START_LOADING');

      await axios.get(`/super-admin/employees/getForAdmin/${this.selectedAdministrator.id}`).then((response) => {
        this.employees = response.data;
      }).finally(() => this.$store.commit('loader/END_LOADING'));
    },
    showEmployee(employee) {
      this.$router.push(`/super-admin/employees/${employee.id}/edit`)
    },
    async importEmployees() {
      if (!this.selectedAdministrator) return;

      this.$store.commit('loader/START_LOADING');

      await axios.get(`/super-admin/employees/import/${this.selectedAdministrator.id}`)
        .then(() => {
          this.loadEmployees()
          toast('Uspešno preuzimanje objekta.', variants.SUCCESS)
        })
        .finally(() => this.$store.commit('loader/END_LOADING'));
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row mb-2">
      <div class="col-12 col-md-6 d-flex">
        <label class="col-form-label mr-2" for="administrator">Firma:</label>
        <VueBootstrapAutocomplete
          class="autocomplete mr-2"
          id="administrator"
          :data="administrators"
          :serializer="(item) => item.company_name"
          :minMatchingChars="0"
          showOnFocus
          @hit="selectedAdministrator = $event"
        />
      </div>   
      <div class="col-12 col-md-6 d-flex align-items-end justify-content-end">
        <b-dropdown right variant="primary" class="mr-2">
          <template slot="button-content">
            <i class="fas fa-file-download mr-1"></i>
              Preuzmi datoteke
            <i class="mdi mdi-chevron-down"></i>
          </template>
          <b-dropdown-item :disabled="!this.selectedAdministrator" @click="downloadEmployeesFomAdmin()">Spisak objekta - Excel</b-dropdown-item>
        </b-dropdown>
        <confirmation-modal 
          variant="primary"
          message="Da li ste sigurni da želite da učitate objekte?"
          title="Preuzmi objekte"
          buttonText="Preuzmi objekte"
          @onSubmit="importEmployees" 
          :disabled="!selectedAdministrator"/>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <b-table :items="employees" :fields="fields" striped responsive
                 class="border-left border-right border-bottom"
                 selectable
                 @row-clicked="showEmployee"
        >
        </b-table>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .search-box .form-control {
    border-radius: 0.25rem;
  }

  .autocomplete {
    width: 100%;
  }
</style>
